import { useAuthState } from '@pepper/ui'

import { getGuestName } from '../utils/functions/collaboration'

// stable guest id for the lifetime of the page — multiple anonymous tabs
// see different ids, which is what we want for awareness/presence
const GUEST_USER_ID = `guest-${crypto.randomUUID()}`
const GUEST_USER_NAME = getGuestName(GUEST_USER_ID)

export function useDocPermissions() {
  const { user } = useAuthState()
  const isAuthenticated = Boolean(user?.uid)

  const currentUser = isAuthenticated
    ? {
        id: user.uid as string,
        name: user.full_name ?? 'Anonymous',
        avatar: user.avatar ?? null,
      }
    : { id: GUEST_USER_ID, name: GUEST_USER_NAME, avatar: null }

  return { currentUser }
}
